export enum IssueFieldNames {
  amountPercentage = 'amountPercentage',
  assignee = 'assignee',
  circumstances = 'circumstances',
  issueVerification = 'issueVerification',
  delayReason = 'delayReason',
  rejectionReason = 'rejectionReason',
  completedAmount = 'completedAmount',
  completionDateDelay = 'completionDateDelay',
  contaminatedSoilScale = 'contaminatedSoilScale',
  contractNumbers = 'contractNumbers',
  costCode = 'costCode',
  createdBy = 'createdBy',
  creationDate = 'createdAt',
  daysOfInabilityToWork = 'daysOfInabilityToWork',
  decisionToImposeFine = 'decisionToImposeFine',
  description = 'description',
  detectionDate = 'detectionDate',
  documents = 'documents',
  linkedDocumentation = 'linkedDocumentation',
  effect = 'effect',
  environmentalAspect = 'environmentalAspect',
  estimatedCost = 'estimatedCost',
  executedByCompanies = 'executedByCompanies',
  executor = 'executor',
  expectedFine = 'expectedFine',
  finalCompletionDate = 'finalCompletionDate',
  finalCost = 'finalCost',
  finalStartDate = 'finalStartDate',
  hashtag = 'hashtag',
  hazardCategory = 'hazardCategory',
  impact = 'impact',
  imposedFine = 'imposedFine',
  issueNumber = 'issueNumber',
  level = 'level',
  modificationDate = 'modifiedAt',
  modifiedBy = 'modifiedBy',
  personUnableToWork = 'personUnableToWork',
  positionOnMap = 'positionOnMap',
  proposedCorrectiveAction = 'proposedCorrectiveAction',
  targetResponseToAuthorDate = 'targetResponseToAuthorDate',
  finalResponseToAuthorDate = 'finalResponseToAuthorDate',
  responseToAuthorDelay = 'responseToAuthorDelay',
  rootCauses = 'rootCauses',
  site = 'site',
  soilLeakageScale = 'soilLeakageScale',
  solutionMethod = 'solutionMethod',
  solutionProposal = 'solutionProposal',
  spilledSubstance = 'spilledSubstance',
  stage = 'stage',
  startDateDelay = 'startDateDelay',
  subcontractorRepresentative = 'subcontractorRepresentative',
  subcontractors = 'subcontractors',
  targetAmount = 'targetAmount',
  targetCompletionDate = 'targetCompletionDate',
  targetStartDate = 'targetStartDate',
  title = 'title',
  waterLeakageScale = 'waterLeakageScale',
  workTypes = 'workTypes',
  numberOfEmployees = 'numberOfEmployees',
  priority = 'priority',
  projectStage = 'projectStage',
  sickLeaveStartDate = 'sickLeaveStartDate',
  sickLeaveEndDate = 'sickLeaveEndDate',
  supervisor = 'supervisor',
  victim = 'victim',
  victimJobTitle = 'victimJobTitle',
  employeeNumber = 'employeeNumber',
  employmentType = 'employmentType',
  immediateMeasures = 'immediateMeasures',
  victimActivity = 'victimActivity',
  injuryTypes = 'injuryTypes',
  injuredBodyParts = 'injuredBodyParts',
  applicationNumber = 'applicationNumber',
  productType = 'productType',
  producerDistributor = 'producerDistributor',
  typeModel = 'typeModel',
  installationLocation = 'installationLocation',
  requirements = 'requirements',
  installationBasis = 'installationBasis',
  constructionProductDocuments = 'constructionProductDocuments',
  deviceDocuments = 'deviceDocuments',
  additionalDocuments = 'additionalDocuments',
}

// those fields can be auto-filled with a default date
// depending on the default days set in the visible field configuration
export const TARGET_DATE_FIELDS = new Set([
  IssueFieldNames.targetCompletionDate,
  IssueFieldNames.targetStartDate,
  IssueFieldNames.targetResponseToAuthorDate,
]);
